export function isHostOptionsJsonValid(jsonObjectString) {
  jsonObjectString = jsonObjectString.trim();
  if (jsonObjectString[jsonObjectString.length - 1] == ';') {
    jsonObjectString = jsonObjectString.substring(0, jsonObjectString.length - 1); //Remove last character of string if its ";"
  }
  let indx = jsonObjectString.indexOf('=');
  let jsonStr = jsonObjectString.substr(indx + 1).replace(/(\w+:)|(\w+ :)/g, function (matchedStr) {
    return '"' + matchedStr.substring(0, matchedStr.length - 1) + '":';
  });
  jsonStr = jsonStr.replace(/'/g, '"');
  try {
    let json = JSON.parse(jsonStr.trim());
    return { state: true };
  } catch (ex) {
    return { state: false, reason: ex };
  }
}
